import Skeleton from '@cvent/carina/components/Skeleton';
import {Card} from '../card/Card';
import {useSkeletonDelay} from './useSkeletonDelay';

/**
 * Skeleton for Home page (login form + marketing ads)
 * Includes a 300ms delay to prevent flash on fast-loading pages
 */
export const CardSkeleton = () => {
  const show = useSkeletonDelay();

  if (!show) {
    return null;
  }

  return (
    <div className="flex-1 flex flex-wrap items-center justify-center px-4 sm:px-0">
      {/* Login form skeleton */}
      <Card styleClasses="px-4 py-6 md:px-9 md:py-6 w-[372px] box-border max-w-full">
        {/* Title */}
        <div className="pb-8 flex justify-center">
          <Skeleton className="w-[200px] h-[24px] rounded" hasShimmer />
        </div>
        {/* Email field */}
        <div className="mb-4">
          <Skeleton className="w-[60px] h-[16px] rounded mb-2" hasShimmer />
          <Skeleton className="w-full h-[40px] rounded" hasShimmer />
        </div>
        {/* Password field */}
        <div className="mb-4">
          <Skeleton className="w-[80px] h-[16px] rounded mb-2" hasShimmer />
          <Skeleton className="w-full h-[40px] rounded" hasShimmer />
        </div>
        {/* Forgot password link */}
        <div className="mb-4 mt-4 flex justify-center">
          <Skeleton className="w-[120px] h-[20px] rounded" hasShimmer />
        </div>
        {/* Log in button */}
        <Skeleton className="w-full h-[36px] rounded" hasShimmer />
        {/* Divider */}
        <div className="flex items-center mt-8 mb-2 gap-3">
          <Skeleton className="flex-1 h-px rounded" hasShimmer />
          <Skeleton className="w-[140px] h-[16px] rounded" hasShimmer />
          <Skeleton className="flex-1 h-px rounded" hasShimmer />
        </div>
        {/* Create account button */}
        <Skeleton className="w-full h-[36px] rounded" hasShimmer />
      </Card>

      {/* Marketing ads skeleton */}
      <div className="flex flex-col items-center flex-wrap justify-center gap-2 md:ml-[213px] mt-14 sm:mt-8">
        <Skeleton
          className="w-[304px] h-[141px] rounded-[10px] md:w-[416px] md:h-[195px] sm:w-full sm:h-[238px]"
          hasShimmer
        />
        <Skeleton
          className="w-[304px] h-[141px] rounded-[10px] md:w-[416px] md:h-[195px] sm:w-full sm:h-[238px]"
          hasShimmer
        />
      </div>
    </div>
  );
};
